import { PORTAL_IDS } from "../constants/portals";
import { PORTAL as bePortalConfig } from "../constants/portals/beTelecom/portal";
import { PORTAL as chPortalConfig } from "../constants/portals/chTelecom/portal";
import { PORTAL as dePortalConfig } from "../constants/portals/deTelecom/portal";
import { PORTAL as esPortalConfig } from "../constants/portals/esTelecom/portal";
import { PORTAL as frPortalConfig } from "../constants/portals/frTelecom/portal";
import { PORTAL as itPortalConfig } from "../constants/portals/itTelecom/portal";
import { PORTAL as nlPortalConfig } from "../constants/portals/nlTelecom/portal";
import { PORTAL as plPortalConfig } from "../constants/portals/plTelecom/portal";
import { PORTAL as ukPortalConfig } from "../constants/portals/ukTelecom/portal";
import { PORTAL as usPortalConfig } from "../constants/portals/usTelecom/portal";

const portalConfig = portalId => {
  switch (portalId) {
    case PORTAL_IDS.beTelecom:
      return bePortalConfig;
    case PORTAL_IDS.chTelecom:
      return chPortalConfig;
    case PORTAL_IDS.deTelecom:
      return dePortalConfig;
    case PORTAL_IDS.esTelecom:
      return esPortalConfig;
    case PORTAL_IDS.frTelecom:
      return frPortalConfig;
    case PORTAL_IDS.itTelecom:
      return itPortalConfig;
    case PORTAL_IDS.nlTelecom:
      return nlPortalConfig;
    case PORTAL_IDS.plTelecom:
      return plPortalConfig;
    case PORTAL_IDS.ukTelecom:
      return ukPortalConfig;
    case PORTAL_IDS.usTelecom:
      return usPortalConfig;
    default:
      return nlPortalConfig;
  }
};

export { portalConfig };
